.root {
  flex: 1; /* fill height if inside flex container in consumer app */
  display: flex;
  min-width: 0;
  min-height: 0;
  margin: 0;
}

.tooltipValue {
  margin-top: 0.25rem;
}

.tooltipValue > strong {
  font-weight: 600;
  font-size: 1.125em;
}
